import clsx from 'clsx';
import { BaseButton, type BaseButtonProps } from '../base-button';
import styles from './styles.module.scss';
import { useRef } from 'react';

type Props = Omit<BaseButtonProps, 'size' | 'variant' | 'icon'> & {
    size?: 'sm' | 'md' | 'lg' | 'fit' | 'zoom';
    variant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'quinary' | 'close';
    icon?: React.ReactNode;
};

export const ModalButton = ({ size = 'md', variant = 'primary', icon, children, onClick, className, ...props }: Props) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleClickButton = (event: React.MouseEvent<HTMLButtonElement>) => {
        const target = event.currentTarget;
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        target.classList.add('button-dark__active');
        timeoutRef.current = setTimeout(() => {
            target.classList.remove('button-dark__active');
            onClick?.(event);
        }, 400);
    };
    return (
        <BaseButton
            {...props}
            onClick={handleClickButton}
            data-playsound="ting"
            className={clsx(styles['modal-button'], styles[`modal-button--${size}`], styles[`modal-button--${variant}`], 'button-dark', className)}
        >
            {icon && <span className={styles['modal-button__icon']}>{icon}</span>}
            <span className={styles['modal-button__text']}>{children}</span>
        </BaseButton>
    );
};
